/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TCreateMessageForOfferModel = IModel<ICreateMessageForOfferRequest, TCreateMessageForOfferResponse>;

export interface ICreateMessageForOfferRequest {
  /** Комментарий **/
  comment?: string | null;
  /** Название компании (если профиль публичный) **/
  companyName?: string | null;
  /** Код подтверждения телефона **/
  confirmationCode?: string | null;
  /** E-mail **/
  email: string;
  /** ФИО **/
  fullName: string;
  /** Является ли пользователь профессионалом (у него есть профиль агента) **/
  hasAgentProfile?: boolean | null;
  /** Заявку подает собственник **/
  isHomeowner?: boolean | null;
  /** ID объявления (realty) **/
  offerId: number;
  /** Телефон **/
  phone: string;
  /** Приоритетный тип связи **/
  priorityCommunicationChannel?: EPriorityCommunicationChannel | null;
  /** Источник заявки **/
  source?: string | null;
}

export type TCreateMessageForOfferResponse = ICreateMessageForOfferResponse200 | ICreateMessageForOfferResponse400;

export interface ICreateMessageForOfferResponse200 extends IModelResponse<ICreateMessageForOfferResponse> {
  statusCode: 200;
}

export interface ICreateMessageForOfferResponse400 extends IModelResponse<ICreateMessageForOfferResponseError> {
  statusCode: 400;
}

export interface ICreateMessageForOfferResponse {
  /** Время до следующей отправки кода подтверждения **/
  confirmTimeout?: number | null;
  /** ID заявки **/
  id: number;
  /** Статус ответа **/
  status: EStatus;
}

export interface ICreateMessageForOfferResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ICreateMessageForOfferResponse | ICreateMessageForOfferResponseError;

export enum EStatus {
  /** Не правильный код подтверждения **/
  CodeError = 'codeError',
  /** Дубликат **/
  Duplicate = 'duplicate',
  /** Необходимо подтверждение номера телефона **/
  NeedPhoneConfirm = 'needPhoneConfirm',
  /** Успешно **/
  Ok = 'ok',
}

export enum EPriorityCommunicationChannel {
  /** Email **/
  Email = 'email',
  /** Телефон **/
  Phone = 'phone',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ICreateMessageForOfferResponse): TResponse200;
  400(response: ICreateMessageForOfferResponseError): TResponse400;
}
